import API from "./api";
import store from "../store/";

function sendMessage(message) {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for sending data");
  }
  message.channel_id = channelId;

  const url = `/custom-notification`;
  return API.post(url, message);
}

export default {
  sendMessage
};
